import React from 'react';
import Draggable from 'react-draggable';
import {
    OmniStyleComponent, OmniIconComponent, OmniDropdownComponent, Utils
} from '../../../shared';

export class RfpFilterComponent extends React.Component {
    nodeRef = null;
    defaultState = {
        filterOptions: {
            'rfp-name': '',
            'seller': '',
            'start-date': '',
            'financial-supplier': '',
            'recipients': '',
            'end-date': '',
            'budget1': '',
            'budget2': '',
        },
        isMenuActive:false,
        exportStatusOptions : [
            {"label":"Not Exported","value":"Not Exported"},
            {"label":"Campaign Sent","value":"Campaign Sent"},
            {"label":"Error","value":"Error"},
            {"label":"Accepted","value":"Accepted"},
            {"label":"Needs Update","value":"Needs Update"},
            {"label":"Synced","value":"Synced"},
            {"label":"Sync Error","value":"Sync Error"} 
        ]
    };
    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.nodeRef = React.createRef();
    }
    
    componentDidMount() {this.handleDropdownClick();}

    /**
    * Handles the click event on the dropdown.
    */
    handleDropdownClick() {
        if (!this.loaded) {
            this.loaded = true;
            // Get all dropdowns on the page that aren't hoverable.
            this.dropdowns = document.querySelectorAll('.dropdown:not(.is-hoverable)');

            if (this.dropdowns.length > 0) {
                // For each dropdown, add event handler to open on click.
                this.dropdowns.forEach((element) => {
                    element.addEventListener('click', (event) => {
                        //first close all dropdown
                        this.closeDropdowns(event);
                        if (!element.classList.contains("is-active")) {
                            element.classList.toggle('is-active');
                            let container = document.querySelectorAll('.dropdown-content');
                            let exists = false;
                            container.forEach((item) => {
                                if ((!exists && item === event.target) || item.contains(event.target)) {
                                    exists = true
                                }
                            })

                            if (!exists) {
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        }
                    });
                });

                // If user clicks outside dropdown, close it.
                document.addEventListener('click', (event) => {
                    this.closeDropdowns(event);
                });
            }
        }
    }

    /**
     * Closes all dropdowns by removing the 'is-active' class from their elements.
     * @param {Event} event - The event object that triggered the function.
     * */
    closeDropdowns = (event) => {
        this.dropdowns.forEach((element) => {
            element.classList.remove('is-active');
        });
    }

    /**
    * The above code is a JavaScript function called `toggleMenu` that is used to toggle the
    * visibility of a dropdown menu. When the function is called, it prevents the default behavior of
    * the event and stops it from propagating further. It then toggles the visibility of the dropdown
    * menu by adding or removing the CSS class "show" to the element with the ID
    * "dropdown-menu-content".
    * @param {html event} event
    */
    toggleMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        document.getElementById("dropdown-menu-content").classList.toggle("show");
        const isMenuActive = document.getElementById("dropdown-menu-content")?.classList.contains("show") ? true : false;
        if(isMenuActive){
            document.querySelectorAll("om2-dropdown-impl").forEach(eachEle =>{
                eachEle.shadowRoot.querySelector(".dropdown-content").style.position = "initial";
            });
        }
        this.setState({isMenuActive})
    }

    /**
    * Retrieves the event target element from the given event object.
    * @param {Event} e - The event object.
    * @returns {HTMLElement} The target element of the event.
    */
    getEventTarget(e) {e = e || window.event;return e.target || e.srcElement;}

    /**
    * Callback function called when the value of an input changes.
    * @param {string} type - The type of input being changed.
    * @param {Event} event - The event object triggered by the input change.
    * @returns {void}
    */

    onValueChange = (type, event) => {
        let target = this.getEventTarget(event);
        const value = target.textContent;
        this.updateFilterOptions(type, value);
    };

    /**
    *  Description The above code is defining a function called `onDataChange` that takes two parameters: `type`
    *  and `event`. Inside the function, it checks if the `type` parameter is either "start_date" or
    *  "end_date". If it is, it formats the `value` of the `event.target` using a utility function
    *  called `formatDateObject` from a module called `Utils`. Finally, it calls another function
    *  called `updateFilterOptions` with the `type` and `value` parameters.
    *  @param {string} type
    *  @param {html event} event
    */
    onDataChange = (type, event) => {
        let value = Utils.getValue(event);
        if (type === "start-date" || type === "end-date") {
            value = Utils.formatDateObject(value);
        }
        this.updateFilterOptions(type, value);
    }

    /**
     * Updates the filter options in the component's state.
     *
     * @param {string} type - The type of filter option to update.
     * @param {any} value - The new value for the filter option.
     * @returns {void}
     */
    updateFilterOptions = (type, value) => {
        let filterOptions = { ...this.state.filterOptions };
        filterOptions[type] = value;
        this.setState({ filterOptions: filterOptions });
    }

    /**
    * Description The above code is defining an arrow function called `onClearfFilter` that takes an event object
    * as its parameter. Inside the function, it sets the `filterOptions` state of the component to its
    * default state, calls the `onApplyFilter` function with the default filter options as its
    *  argument, and then toggles the menu. This function is likely used to reset the filter options to
    *  their default values and apply the default filter to the data being displayed. 
    *  @param {html event} event
    */
    onClearfFilter = (event) => {
        if (Object.values(this.state.filterOptions).some(value => value)) {
            this.setState({ filterOptions: this.defaultState.filterOptions });
            this.props.onApplyFilter(this.defaultState.filterOptions);
            this.toggleMenu(event);
        }
    }

    /**
    * Description The above code is defining an arrow function called `applyFilter` that takes an event as an
    * argument. Within the function, it calls a function `onApplyFilter` that is passed as a prop to
    * the component, and passes in the current state of `filterOptions` as an argument. It then calls
    * another function `toggleMenu` and passes in the event as an argument. The purpose of this code
    * is to apply a filter based on the current state of `filterOptions` and then toggle a menu.
    * @param {html event} event
    */
    applyFilter = (event) => {
        this.props.onApplyFilter(this.state.filterOptions, true);
        this.toggleMenu(event);
    }


    // Method to find out passed item is null, mostly used as callback method in array methods
    isNull = (item) => !item

    render() {
        const {isMenuActive,filterOptions} = this.state;
        const disableApplyFilter=(Object.values(filterOptions).every(this.isNull));  // If every value is null, disable the apply button
       return (
            <OmniStyleComponent className="menu-wrapper">
                <div className={`menu-trigger ${isMenuActive ? "bg-blue" : ""}`} onClick={this.toggleMenu}>
                <omni-tooltip> 
                <button  slot="invoker" aria-haspopup="true" className={`button is-text is-shadowless filter-button ${isMenuActive ? "bg-blue" : ""}`}> 
                <OmniIconComponent slot="end" className="menu-trigger is-size-2 has-text-almost-black"
                        icon-id="omni:interactive:filter"></OmniIconComponent> 
                    </button>
                    <div slot="content">Filters</div>
                        </omni-tooltip>
                </div>
                <Draggable nodeRef={this.nodeRef} axis="both" bounds='body'>
                    <div ref={this.nodeRef}>
                        <div className="dropdown-menu-content rfp-filter-container" id="dropdown-menu-content" role="menu">
                            <div>
                                <div className="media-flex media-justify-space-between filter-header">
                                    <span className='filter-title'>Filters</span>
                                    <OmniIconComponent onClick={this.toggleMenu} className="is-size-2 has-text-almost-black fliter-close-icon"
                                        icon-id="omni:interactive:close"></OmniIconComponent>
                                </div>
                                <hr className='filter-header-bar'/>
                                <div className="filter-sections">
                                    <div className='filter-sections-list'>
                                <section className="section-item media-direction-column">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Rfp name</span>
                                        <a className="media-link" onClick={this.onClearfFilter}>Clear All</a>
                                    </div>
                                    <div className="full-width">
                                        <input type="text" placeholder="Rfp Name" value={this.state.filterOptions['rfp-name']}
                                            onChange={this.onDataChange.bind(this, 'rfp-name')} className="input text filter-field">
                                        </input>
                                    </div>
                                </section>
                                
                                <section className="section-item media-direction-column">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Export Status</span>
                                    </div>
                                    <div className="full-width">
                                    <OmniDropdownComponent
                                        typeahead
                                        searchindropdown
                                        options={this.state.exportStatusOptions}
                                        value={this.state.filterOptions.status?[this.state.filterOptions.status]:[]}
                                        onDropdownChange={(event) => this.onDataChange("status", event)}
                                        placeholder="Select Option"
                                        hidefooter={true}
                                        ></OmniDropdownComponent>
                                    </div>
                                </section>

                                <section className="section-item media-direction-column">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Seller</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="text" placeholder="Seller" value={this.state.filterOptions['seller']}
                                            onChange={this.onDataChange.bind(this, 'seller')} className="input text filter-field">
                                        </input>
                                    </div>
                                </section>
                                       
                                <section className="section-item media-direction-column">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Financial Supplier</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="text" placeholder="Financial Supplier" value={this.state.filterOptions['financial-supplier']}
                                            onChange={this.onDataChange.bind(this, 'financial-supplier')} className="input text filter-field">
                                        </input>
                                    </div>
                                </section>
                                       
                                <section className="section-item media-direction-column">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Emails</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="text" placeholder="Emails" value={this.state.filterOptions['recipients']}
                                            onChange={this.onDataChange.bind(this, 'recipients')} className="input text filter-field">
                                        </input>
                                    </div>
                                </section>

                                <section className="section-item media-direction-column side-section">
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-left-box filter-label-text">
                                        <span className="filter-label-text">Start date</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="date" data-date={this.state.filterOptions['start-date'] !== "" ? this.state.filterOptions['start-date'] : "MMM DD, YYYY" } value={this.state.filterOptions['start-date']} 
                                            onChange={this.onDataChange.bind(this, 'start-date')} className="input date is-large filter-field input-with-icon">
                                        </input>
                                    </div> 
                                    </label>
                                    <label>
                                    <div className="media-flex media-justify-space-between filter-right-box is-7 filter-label-text">
                                        <span className="filter-label-text">End date</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="date" data-date={this.state.filterOptions['end-date'] !== "" ? this.state.filterOptions['end-date'] : "MMM DD, YYYY" }onChange={this.onDataChange.bind(this, 'end-date')} value={this.state.filterOptions['end-date']} className="input date is-large filter-field input-with-icon">
                                        </input>
                                    </div>
                                    </label>
                                </section>

                                <section className="section-item media-direction-column mt-4 side-section">
                                   <label>
                                    <div className="media-flex media-justify-space-between filter-left-box is-7 filter-label">
                                        <span className="filter-label-text">Budget 1</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.budget1}
                                        onChange={this.onDataChange.bind(this, 'budget1')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                    <label>
                                    <div className="media-flex media-justify-space-between filter-right-box is-7 filter-label">
                                        <span className="filter-label-text">Budget 2</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.budget2}
                                        onChange={this.onDataChange.bind(this, 'budget2')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                    
                                    <div className="action-btns">
                                        <input type="button" className={`${disableApplyFilter ? "apply-filter" : "btn-primary"}`} value="Apply filters" title="Filter" disabled={disableApplyFilter}
                                            onClick={this.applyFilter}></input>
                                    </div>
                                </section>

                                
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </OmniStyleComponent>
        )
    }

}